import React, { useMemo } from "react";
var HtmlRenderer = function(props) {
    var content = props.content;
    var html = content.trim();
    return useMemo(function() {
        var _div;
        // Unlikely to work in SSR
        var div = document.createElement("div");
        div.innerHTML = html;
        return Array.from((_div = div) == null ? void 0 : _div.children).map(function(child, i) {
            var type = child.localName;
            var attrs = Object.values(child.attributes).reduce(function(acc, attr) {
                acc[attr.name] = attr.value;
                return acc;
            }, {});
            attrs.dangerouslySetInnerHTML = {
                __html: child.innerHTML
            };
            attrs.key = attrs.key ? attrs.key : i;
            return /*#__PURE__*/ React.createElement(type, attrs);
        });
    }, [
        html
    ]);
};
export { HtmlRenderer };

//# sourceMappingURL=index.js.map